var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white"},[_c('safety-toolbar',{attrs:{"heading":"Health & Safety Apps"}}),_c('addon-app-tab',{attrs:{"ui-location":"Health & Safety Module"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }